import { NgModule } from '@angular/core';
import { InViewDirective } from './in-view.directive';

@NgModule({
	imports: [],
	declarations: [InViewDirective],
	exports: [InViewDirective],
})
export class DirectivesModule {}
